import "../../themes/global.css"
import "./assets/static/post.css"
// import MarkdownText from "../markdownText";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { postsReference } from "../../config/firebase";
import { DocumentData, getDocs, query, where } from "firebase/firestore";
import { Remark } from "react-remark";

const Post = () => {

    const { uid } = useParams();

    const [post, setPost] = useState<any>([]);

    useEffect(() => {
        const get = async () => {
            const q = query(postsReference, where('uid', '==', uid));
            const doc = await getDocs(q);
            const data = doc.docs[0].data();
            setPost(data);
        }
        get();
    }, [uid])

    return (
        <>
            <main>
                <span className="sidebar"></span>
                <div className="content">
                    <div className="post-structure">
                        <h1 className="title">{post.title}</h1>
                        <div className="subtitle">Published on: {post.date}</div>
                        <br/>

                        {/* TODO: Make remark work correctly, by storing the markdown text as .md file
                            inside Firebase, instead of a string in a collection. */}
                        <div className="markdown-text">
                            <Remark>
                                {post.markdown}
                            </Remark>
                        </div>
                    </div>
                </div>
                <span className="sidebar"></span>
            </main>
        </>
    )
}
export default Post;